import * as platform from 'platform';
import { ObjectUtils } from '@colonist/utils';
const knownBots = [
    // Weird behavior in Google Analytics coming from a user with these attributes
    // https://user-images.githubusercontent.com/6215305/125231510-790e6a80-e30d-11eb-88ae-9546733c16c2.png
    // https://cdn.discordapp.com/attachments/710554327428890716/860496911081013268/unknown.png
    {
        browserName: 'Chrome',
        browserVersion: '15.0.87',
        osName: 'Linux'
    }
];
function getUserMachineDetails() {
    var _platform_os;
    return {
        browserName: platform.name,
        browserVersion: platform.version,
        osName: (_platform_os = platform.os) === null || _platform_os === void 0 ? void 0 : _platform_os.family
    };
}
export function isCrawler() {
    const userMachine = getUserMachineDetails();
    for (const bot of knownBots){
        if (ObjectUtils.isObjectEqual(bot, userMachine)) return true;
    }
    return false;
}
